import { HiExclamation } from 'react-icons/hi'

import { Box, Flex } from '@chakra-ui/react'

interface TailgateAlertLabelIProps {
  startText: string
  endText?: string
  boldText?: string
}

export const TailgateAlertLabel = ({
  startText,
  endText,
  boldText,
}: TailgateAlertLabelIProps) => (
  <Flex alignItems='center' color='#D11D3A' flexDirection='row' pb='2' pt='5'>
    <HiExclamation size='24px' />
    <Box
      data-testid='TailgateAlertLabel'
      fontSize='16px'
      fontWeight='medium'
      letterSpacing='-0.53px'
      ml='1'
    >
      {startText}
      <Box as='span' fontWeight='bold'>
        {boldText}
      </Box>{' '}
      {endText}
    </Box>
  </Flex>
)
